/**
 * Billing Success — Confirms card on file and redirects to dashboard
 */
import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import axios from 'axios';
import { Card, CardContent } from './ui/card';
import { CheckCircle, Loader2 } from 'lucide-react';

const API = process.env.REACT_APP_BACKEND_URL;

const BillingSuccess = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [status, setStatus] = useState('confirming');
  const orgId = searchParams.get('org_id');

  useEffect(() => {
    const confirm = async () => {
      if (!orgId) { setStatus('error'); return; }
      try {
        const token = localStorage.getItem('access_token');
        await axios.post(`${API}/api/organizations/${orgId}/confirm-card`, {}, {
          headers: { Authorization: `Bearer ${token}` }
        });
        setStatus('success');
        setTimeout(() => navigate('/dashboard', { replace: true }), 2000);
      } catch (e) {
        setStatus('error');
      }
    };
    confirm();
  }, [orgId, navigate]);

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4">
      <Card className="max-w-sm w-full text-center">
        <CardContent className="py-10">
          {status === 'confirming' && (
            <>
              <Loader2 className="h-12 w-12 animate-spin text-emerald-500 mx-auto mb-4" />
              <p className="text-gray-600">Confirming your payment method...</p>
            </>
          )}
          {status === 'success' && (
            <>
              <CheckCircle className="h-12 w-12 text-emerald-500 mx-auto mb-4" />
              <h2 className="text-xl font-bold text-gray-900 mb-2">Payment Method Added</h2>
              <p className="text-gray-600">Your account is now fully active. Redirecting to your dashboard...</p>
            </>
          )}
          {status === 'error' && (
            <>
              <p className="text-red-600 mb-4">Something went wrong. Please try again or contact support.</p>
              <button onClick={() => navigate('/dashboard')} className="text-emerald-600 underline">Go to Dashboard</button>
            </>
          )}
        </CardContent>
      </Card>
    </div>
  );
};

export default BillingSuccess;
